import i18n from '@/lang'

const $t = (label: string, replaceObj?: any) => {
  const { locale, getLocaleMessage } = i18n.global
  const langObj = getLocaleMessage(locale.value)
  if (!langObj) return label
  const keyList: string[] = label.split('.')
  let objVal = keyList.reduce((objRow: any, currentKey: string) => objRow && objRow[currentKey], langObj)
  if (replaceObj) {
    Object.keys(replaceObj).forEach((k: string) => {
      objVal = objVal.replace(`{${k}}`, replaceObj[k])
    })
    // 替换
  }
  return (objVal || label) as string
}
export default $t
